/**
 * Translate description: Table component
 */

import { Fragment, useContext } from 'react';

import { useLanguageContext } from "../../../context/LanguageContext";
import AppContext from '../../../context/AppContext';

import Filter from '../../../components/filter/Filter';


import {
  ContentTable, ContentHeader, ContentHeaderItem, ContentBody,
  ContentBodyCheckbox, ContentBodyItem,
  ContentBodyItemStatus,
  ContentBodyItemTranslations, ContentBodyItemEdit
} from '../../../components/blocks/ContentTable';

import { ContentList, ContentListRow, ContentListItem } from '../../../components/blocks/ContentList';
import moment from 'moment';
import DateFilter from '../../../components/filter/FilterDate';


function Row({ row }) {
  const { t } = useLanguageContext();
  return <tr>
    <ContentBodyCheckbox row={row} />
    <ContentBodyItem>{row.path}</ContentBodyItem>
    <ContentBodyItem>{row.visits}</ContentBodyItem>
    <ContentBodyItem>{moment(row.last_visit).format('YYYY-MM-DD HH:mm:ss')}</ContentBodyItem>
  </tr>
}
function MobileRow({ row }) {
  const { t } = useLanguageContext();

  return <ContentListRow key={row.id} row={row}>
    <ContentListItem>{row.path}</ContentListItem>
    <ContentListItem>{row.visits}</ContentListItem>
    <ContentListItem>{moment(row.last_visit).format('YYYY-MM-DD HH:mm:ss')}</ContentListItem>
  </ContentListRow>
}
export default function Content() {
  const { t } = useLanguageContext();
  const { listItems, totals } = useContext(AppContext);
  const { loading } = useContext(AppContext);

  return (
    <Fragment>
      <Filter fields={['path']} search_label="Search by path">
        <DateFilter></DateFilter>
      </Filter>

      <ContentTable>
        <ContentHeader>
          <ContentHeaderItem title={t('Path')} />
          <ContentHeaderItem title={t('Visits')} sortBy="visits" />
          <ContentHeaderItem title={t('Last visit')} />
        </ContentHeader>

        <ContentBody colspan={7}>
          {(Array.isArray(listItems) && !loading && listItems?.length) ? (
            listItems.map((row) => (<Row key={row.id} row={row}></Row>))
          ) : null}
          {!!listItems?.length && <tr>
            <ContentBodyItem>{t("Total: ")}</ContentBodyItem>
            <ContentBodyItem></ContentBodyItem>
            <ContentBodyItem>{totals.visits}</ContentBodyItem>
            <ContentBodyItem></ContentBodyItem>
          </tr>}
        </ContentBody>
      </ContentTable>

      <ContentList>
        {(Array.isArray(listItems) && !loading && listItems?.length) ? (
          listItems.map((row) => (
            <MobileRow key={row.id} row={row} />
          ))
        ) : null}
        {!!listItems?.length && <ContentListRow row={{ id: "", no_btns: true }}>
          <ContentListItem>{t("Total: ")} {totals.visits}</ContentListItem>
        </ContentListRow>
        }
      </ContentList>

    </Fragment >
  );
}